import * as Yup from 'yup';
import { DISABLED_CAPTCHA_COMPANY_UUIDS } from 'features/common/helpers/constants';

export default function ConsentValidation(companyUUID) {
    const disabledCaptcha = DISABLED_CAPTCHA_COMPANY_UUIDS.includes(companyUUID);

    const baseSchema = {
        agree: Yup.boolean().required().oneOf([true], 'Agree field must be checked'),
    };

    if (!disabledCaptcha) {
        baseSchema.captcha = Yup.string().required('Captcha required');
    }

    return Yup.object().shape(baseSchema);
}
